export const AGENTS_ERROR = 'AGENTS_ERROR';
export const AGENTS_REQUEST = 'AGENTS_REQUEST';
export const AGENTS_SUCCESS = 'AGENTS_SUCCESS';
